// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"detailLayanan_contentContainer__ULjV0"};